import type { PlaidProduct } from "../hooks/usePlaid";
import { ApiClient } from "./ApiClient";

export default class PlaidClient extends ApiClient {
  async createCraLinkToken(vaultId: string) {
    const response = await this.post("/v2/plaid/token/cra/create", { vault_id: vaultId });
    return response.data;
  }

  async createIncomeLinkToken(vaultId: string) {
    const response = await this.post("/v2/plaid/token/income/create", { vault_id: vaultId });
    return response.data;
  }

  async pending(vaultId: string, product: PlaidProduct) {
    const response = await this.post("/v2/plaid/report/pending", {
      vault_id: vaultId,
      product,
    });
    return response.data;
  }

  async exchangePublicToken(data: Record<string, unknown>) {
    const response = await this.post("/v2/plaid/token/exchange", data);
    return response.data;
  }
}
